import React, { useState, useEffect } from "react";
import { projectsNav } from "./Data";

import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

// import components
import WorkItems from "./WorkItems";

const Projects = () => {
  const [item, setItem] = useState({ name: "all" });
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState(0);

  const [projectData, setProjectData] = useState([]);

  const fetchPost = async () => {
    const querySnapshot = await getDocs(collection(db, "projects"));
    console.log(querySnapshot.docs);
    const newData = querySnapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    setProjectData(newData);
  };

  useEffect(() => {
    fetchPost();
  }, []);


  useEffect(() => {
    // get projects based on item
    if (item.name === "all") {
      setProjects(projectData);
    } else {
      const newProjects = projectData.filter((project) => {
        return project.category.toLowerCase() === item.name;
      });
      setProjects(newProjects);
    }
  }, [item, projectData]);

  const handleClick = (e, index) => {
    setItem({ name: e.target.textContent.toLowerCase() });
    setActive(index);
  };

  return (
    <div>
      {/* projects nav */}
      <div className="work__filters">
        {projectsNav.map((item, index) => {
          return (
            <span
              onClick={(e) => {
                handleClick(e, index);
              }}
              className={`${active === index ? "active-work" : ""} work__item`}
              key={index}
            >
              {item.name}
            </span>
          );
        })}
      </div>
      {/* projects */}
      <div className="work__container container grid">
        {projects.map((item) => {
          return <WorkItems item={item} key={item.id} />;
        })}
      </div>
    </div>
  );
};

export default Projects;
